import i18n from 'modules/core/lib/i18n'

import { InsightCard } from 'modules/project_management/components/InsightCard'

import CostTooltipMessage from 'modules/project_management/pages/ProjectDetailsPage/tabs/OverviewPage/FinancialDetailsSection/tooltips/CostTooltipMessage'

interface CostToDateInsightProps {
  costToDate: number
  currency: string
  fixedCosts: number
  hasPendingSpendings: boolean
  hoursPerCostRate: number
  spendingCostsApprovedAmountCents: number
  plannedCents?: number
}

const CostToDateInsight = ({
  costToDate,
  currency,
  fixedCosts,
  hasPendingSpendings,
  hoursPerCostRate,
  spendingCostsApprovedAmountCents,
  plannedCents,
}: CostToDateInsightProps) => (
  <InsightCard.Cost
    totalCost={costToDate}
    currency={currency}
    showWarningTag={hasPendingSpendings}
    warningTooltipLabel={i18n.t(
      'project_management.overview.banners.pending_spendings.tooltip_message'
    )}
    info={
      <CostTooltipMessage
        currency={currency}
        fixedCosts={fixedCosts}
        hoursPerCostRate={hoursPerCostRate}
        spendingCostsApprovedAmountCents={spendingCostsApprovedAmountCents}
        title={i18n.t(
          'project_management.overview.sections.financial_details.insights.cost_to_date.title'
        )}
      />
    }
    plannedCost={plannedCents}
    title={
      plannedCents
        ? i18n.t(
            'project_management.overview.sections.financial_details.insights.cost_to_date.title_with_estimated'
          )
        : i18n.t(
            'project_management.overview.sections.financial_details.insights.cost_to_date.title'
          )
    }
  />
)

export default CostToDateInsight
